// generated by srcset-codegen
import src from "./onboarding2.png";

const width = 436;
const height = 300;
export default { src, width, height };
